<template>
    <!-- 产品服务 -->
    <div class="service">
        <div v-for="item in list">
            <ServiceItem :serviceItem="item" />
        </div>
    </div>
</template>
  
<script>
import ServiceItem from './ServiceItem.vue';
export default {
    name: 'Service',
    components: {
        ServiceItem,
    },
    data() {
        return {

        }
    },
    computed: {
        list() {
            return this.$t('service.list');
        }
    },
}
</script>
  
<style scoped>
.service {
    padding: 26px;
}
</style>
  